module.exports = __webpack_public_path__ + "img/cards2.daf2a6e4.svg";